import InputRow from './InputRow';

export default InputRow;